import React, { forwardRef } from 'react';
// STYLES

// LIBRARIES
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

// MISC
import { SnackbarTypes } from "models/GeneralTypes/generalTypes";

// ASSETS

// REDUX
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { snackbarProps, toggleSnackbarState } from "slices/uiSlice";
import { useTranslation } from 'react-i18next';

// COMPONENTS
const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} {...props} />;
});

const SnackbarAtom = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const snackbarData = useAppSelector(snackbarProps);
  const { t } = useTranslation();

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS


  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(toggleSnackbarState({
      isVisible: false,
      type: "",
      item: "",
    }))
  };

  const handleRenderContent = () => {
    switch (snackbarData.type) {
      case SnackbarTypes.SUPPORT_EDIT_SUCCESS:
        if (snackbarData?.item === t("snackbar.article")) {
          return <>{`${snackbarData?.item} ${t("snackbar.editArticle")}`}</>
        } else return <>{`${snackbarData?.item} ${t("snackbar.editCategory")}`}</>
      case SnackbarTypes.SUPPORT_SAVE_SUCCESS:
        if (snackbarData?.item === t("snackbar.article")) {
          return <>{`${snackbarData?.item} ${t("snackbar.saveArticle")}`}</>
        } else return <>{`${snackbarData?.item} ${t("snackbar.saveCategory")}`}</>
      case SnackbarTypes.SUPPORT_DELETE_SUCCESS:
        if (snackbarData?.item === t("snackbar.article")) {
          return <>{`${snackbarData?.item} ${t("snackbar.deleteArticle")}`}</>
        } else return <>{`${snackbarData?.item} ${t("snackbar.deleteCategory")}`}</>
      case SnackbarTypes.BLOCK_SUCCESS:
        return <>{`${snackbarData?.item} ${t("snackbar.block")}`}</>
      case SnackbarTypes.UNBLOCK_SUCCESS:
        return <>{`${snackbarData?.item} ${t("snackbar.unblock")}`}</>
      case SnackbarTypes.VERIFY_SUCCESS:
        return <>{`${snackbarData?.item} ${t("snackbar.verify")}`}</>
      case SnackbarTypes.SETTINGS_SUCCESS:
        return <>{t("snackbar.settings")}</>
      case SnackbarTypes.SUPPORT_ERROR:
        return <>{t("snackbar.error")}</>
    }
  };

  return (
    <>
      <Snackbar
        open={snackbarData?.isVisible}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={snackbarData.type === SnackbarTypes.SUPPORT_ERROR ? "error" : "success"}
          variant='standard'
        >
          {handleRenderContent()}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SnackbarAtom;
